import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionToggleCardArchivedCodes = {
  AutomationV2ExecutionActionToggleCardArchivedFailedToToggleCardArchived: {
    code: 'automation-v2-execution-action/toggle-card-archived-failed-to-toggle-card-archived',
    explanation: `Falha ao arquivar/desarquivar card.

**Causas comuns:**
- Card já está no estado desejado (se a ação for explícita)
- Erro de permissão ou bloqueio do card

**Como diagnosticar:**
Verifique o estado atual do card.`,
    localizations: {},
    message: 'Houve um erro ao tentar alternar o estado arquivado do card.',
    supportingDocs: [
      {
        name: 'Ação de Arquivar/Desarquivar Card',
        path: '/wiki/docs/automations/actions/toggle-card-archived',
      },
    ],
  },
  AutomationV2ExecutionActionToggleCardArchivedMissingCardId: {
    code: 'automation-v2-execution-action/toggle-card-archived-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message: 'ID do card não foi fornecido.',
    supportingDocs: [
      {
        name: 'Ação de Arquivar/Desarquivar Card',
        path: '/wiki/docs/automations/actions/toggle-card-archived',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
